var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { DocumentRetrievalLocationStatus } from "healthex-common/document.retrieval.dtos";
import { uniques } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { Disposer } from "../Infra/Disposer";
import { NOT_LOADED } from "../Infra/RemoteData";
import { logLocationSecondaryLabelDisplay } from "./LocationSecondaryLabelDebug";
export class DocumentRetrievalDocumentSelectionViewModel {
    constructor(props) {
        this.disposer = new Disposer();
        this.footerText = NOT_LOADED;
        this.sharingOrgsDialogOpen = false;
        this.parentModel = props.model;
        this.patientConsentUIManager = props.container.patientConsentUIManager;
    }
    run() {
        if (this.patientConsentUIManager.isInteractivePreview || this.patientConsentUIManager.isScreenshotPreviewMode) {
            this.footerText = null;
        }
        else {
            void this.loadSharedOrgNames();
        }
        this.disposer.reaction(() => ({
            locations: this.locationList,
            hideNewProviderLabel: this.parentModel.hideNewProviderLabel,
        }), ({ locations, hideNewProviderLabel }) => {
            for (const location of locations) {
                const needsAuth = location.status === DocumentRetrievalLocationStatus.NEEDS_AUTH ||
                    location.status === DocumentRetrievalLocationStatus.SKIPPED;
                logLocationSecondaryLabelDisplay(location, needsAuth, hideNewProviderLabel);
            }
        }, { fireImmediately: true, name: "DocumentRetrievalDocumentSelectionViewModel_locationSecondaryLabel" });
    }
    stop() {
        this.disposer.dispose();
    }
    async loadSharedOrgNames() {
        this.footerText = await this.parentModel.loadSharedOrgNamesFooterText();
    }
    get isFastenAuthLoading() {
        return this.parentModel.isAuthLoading;
    }
    get fastenPublicId() {
        return this.parentModel.fastenPublicId;
    }
    get fastenPatientId() {
        return this.parentModel.fastenPatientId;
    }
    get isStatic() {
        return this.parentModel.uiState.isStatic;
    }
    get showFastenImmediately() {
        if (this.parentModel.isScreenshotMode)
            return false;
        return this.parentModel.uiState.showFastenImmediately;
    }
    fastenShown() {
        this.parentModel.uiState.showFastenImmediately = false;
    }
    get locationList() {
        return this.parentModel.locationList.filter((location) => !location.isPrevious);
    }
    get previousLocationList() {
        return this.parentModel.locationList.filter((location) => location.isPrevious);
    }
    get hasPreviousLocations() {
        return this.previousLocationList.length > 0;
    }
    get commonPreviousLocationsDate() {
        const dates = this.previousLocationList.map((location) => { var _a, _b; return (_b = (_a = location.updatedAt) === null || _a === void 0 ? void 0 : _a.toLocaleDateString()) !== null && _b !== void 0 ? _b : ""; });
        const uniqueDates = uniques(dates);
        if (uniqueDates.length !== 1)
            return null;
        return uniqueDates[0];
    }
    get previousLocationsCanBeUpdatedWithCLEAR() {
        return !this.patientConsentUIManager.useTefca;
    }
    get isAddingLocationInProgress() {
        return this.parentModel.isAddingLocationInProgress;
    }
    excludeLocation(location) {
        this.parentModel.onLocationExcluded(location);
    }
    includeLocation(location) {
        this.parentModel.onLocationIncluded(location);
    }
    showSharingOrgsDialog() {
        this.sharingOrgsDialogOpen = true;
    }
    hideSharingOrgsDialog() {
        this.sharingOrgsDialogOpen = false;
    }
    async logInToLocation(location) {
        this.parentModel.retryLocations([location]);
    }
}
__decorate([
    observable
], DocumentRetrievalDocumentSelectionViewModel.prototype, "footerText", void 0);
__decorate([
    observable
], DocumentRetrievalDocumentSelectionViewModel.prototype, "sharingOrgsDialogOpen", void 0);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "isFastenAuthLoading", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "showFastenImmediately", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "locationList", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "previousLocationList", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "hasPreviousLocations", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "commonPreviousLocationsDate", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "previousLocationsCanBeUpdatedWithCLEAR", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "isAddingLocationInProgress", null);
